import { FRUITS, SPRITE_EXTENT } from './data/fruits';

/**
 * 열매 도안을 오프스크린 캔버스에 한 번만 구워 두고 재사용한다.
 *
 * 도안 하나가 열 번 가까이 path 를 그리므로, 구슬 60개를 매 프레임 직접 그리면 프레임당
 * 수백 번의 fill 이 된다. 스프라이트로 만들어 두면 프레임당 비용이 예전 원 하나 그릴 때와
 * 같은 drawImage 한 번으로 돌아온다.
 *
 * 128px 은 최대 확대(camera zoom 3 * initialZoom 30 * 구슬 지름 0.5 ≈ 45px)의 두 배 이상이라
 * 확대해도 뭉개지지 않는다.
 */
const SPRITE_PX = 128;

let sprites: HTMLCanvasElement[] | null = null;

function build(): HTMLCanvasElement[] {
  return FRUITS.map((fruit) => {
    const canvas = document.createElement('canvas');
    canvas.width = SPRITE_PX;
    canvas.height = SPRITE_PX;
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    const half = SPRITE_PX / 2;
    // 도안의 단위 좌표계를 스프라이트 중앙에 맞춘다. 본체 반지름 1 이 half/SPRITE_EXTENT 픽셀
    ctx.translate(half, half);
    ctx.scale(half / SPRITE_EXTENT, half / SPRITE_EXTENT);
    fruit.draw(ctx);
    return canvas;
  });
}

/**
 * 첫 호출 때 한 번만 굽는다. 모듈을 불러오는 시점에 document 를 건드리지 않으려는 의도도 있다
 * (scripts/simulate.ts 처럼 DOM 없는 node 환경에서 import 되어도 안전해야 한다)
 */
export function getFruitSprite(index: number): CanvasImageSource {
  if (!sprites) sprites = build();
  return sprites[((index % sprites.length) + sprites.length) % sprites.length];
}
